<template>
  <div class="phone-login">
    <div class="login-body">
      <div class="login-form">
        <!-- <div class="login-form-title">手机登录</div> -->
        <div class="login-form-content">
          <div class="login-mobile-code">
            <div class="login-mobile-input-wrapper">
              <input
                type="tel"
                ref="phone"
                @blur="errmsgChange('phone')"
                @input="inputChange('phone')"
                v-model.number="phone"
                placeholder="请输入手机号"
                autocomplete="tel"
                maxlength="50"
                tabindex="0"
              />
            </div>
            <div class="login-code-input-wrapper">
              <div class="login-button-input">
                <span
                  class="login-button-input-text"
                  :class="{
                    'login-button-input-text_disabled': codeTimer && num !== 60,
                  }"
                  @click="getCode"
                  :disabled="codeTimer && num !== 60"
                  >{{ codemsg }}</span
                >
                <div class="login-button-input-wrapper">
                  <input
                    type="tel"
                    ref="code"
                    @blur="codeBlur"
                    @keyup.enter="userLogin"
                    @input="inputChange('code')"
                    v-model="code"
                    class="login-button-input__input"
                    placeholder="验证码"
                    autocomplete="off"
                    maxlength="50"
                    tabindex="0"
                  />
                </div>
              </div>
            </div>
            <div class="login-error">{{ errmsg }}</div>
            <div class="login-submit-btn-wrapper">
              <button
                type="submit"
                @click="userLogin"
                :class="{ 'login-submit-btn-disabled': btnIsClick }"
                class=""
              >
                登录
              </button>
            </div>
            <div class="login-confirm-info">
              <span
                @click="confirmInfoChange"
                :class="{
                  'login-confirm-info_checkbox_checked': confirmInfo,
                }"
                class="login-confirm-info_checkbox"
                role="checkbox"
                aria-checked="checkbox"
              ></span>
              <span class="login-confirm-info__before-text">登录即同意</span>
              <router-link :to="{ name: 'UserAgreement' }">《用户协议》</router-link>
              <span class="login-confirm-info__before-text">和</span>
              <router-link :to="{ name: 'PrivacyAgreement' }">《隐私协议》</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { GET_CODE, USER_LOGIN } from '@/api/user.js'
import { SET_TOKEN, SET_USER_INFO } from '@/utils/storage.js'

export default {
  name: 'PhoneLogin',
  props: ['type'],
  data () {
    return {
      phone: '',
      code: '',
      codemsg: '获取验证码',
      errmsg: '',
      confirmInfo: true, // 是否同意用户协议
      codeTimer: null, // 获取验证码定时器
      num: 60 // 验证码倒计时
    }
  },
  computed: {
    btnIsClick () {
      let istrue = false
      istrue = this.phone && this.code && this.confirmInfo
      return !istrue
    }
  },
  methods: {
    getCode () {
      // 获取验证码
      if (this.codeTimer || !this.errmsgChange('code')) return
      GET_CODE({ phone: this.phone, scapp: 2 }).then(res => {
        if (res.code !== 200) {
          this.$message.warning(res.message || '获取验证码出错')
        }
      })
      this.num--
      this.codemsg = `${this.num}秒后重新获取`
      this.codeTimer = setInterval(() => {
        if (this.num < 1) {
          clearInterval(this.codeTimer)
          this.codeTimer = null
          this.num = 60
          this.codemsg = '获取验证码'
        } else {
          this.num--
          this.codemsg = `${this.num}秒后重新获取`
        }
      }, 1000)
      this.$refs.code.focus()
    },
    userLogin () {
      if (this.btnIsClick) return
      if (!this.errmsgChange()) return
      const data = { phone: this.phone, smscode: this.code }
      this.$LOGIN01(4)
      USER_LOGIN(data).then((res) => {
        if (res.code === 108) {
          this.errmsg = res.message || '验证码过期或错误'
          return
        }
        if (res.code === 200 && res.data) {
          SET_TOKEN(res.data.token)
          const user = res.data
          user.token = res.data.token
          if (user.id) {
            user.user_id = user.id
          } else if (user.user_id) {
            user.id = user.user_id
          }
          SET_USER_INFO(JSON.stringify(user))
          this.$store.commit('setUserInfo', user)

          // 免责声明
          const shengming = window.localStorage.getItem('disclaimer')
          if (shengming === '0') {
            window.localStorage.removeItem('disclaimer')
          }
          if (this.type === 'popups') {
            this.$store.commit('setLoginShow', false)
            // this.$router.go(0)
          } else {
            const lasturl = document.referrer
            if (lasturl && lasturl.indexOf('qq.com') === -1 && lasturl.indexOf('/login') === -1) {
              window.open(lasturl, '_self')
            } else {
              this.$router.push('/aihome')
            }
          }
        } else {
          this.errmsg = '登录失败'
        }
      })
    },
    codeBlur () {
      if (this.code === '') {
        this.errmsg = '请输入验证码'
        return
      }
      if (this.code !== '' && this.code.length !== 6) {
        this.errmsg = '验证码只能为六位数字'
        return
      }
      this.errmsg = ''
    },
    errmsgChange (type) {
      if (this.phone === '') {
        this.errmsg = '请输入手机号'
        return
      }
      if (type !== 'code' && type !== 'phone') {
        if (this.code === '') {
          this.errmsg = '请输入验证码'
          return
        }
        if (!this.confirmInfo) {
          this.errmsg = '请先勾选用户协议和隐私政策'
          return
        }
        if (this.code !== '' && this.code.length !== 6) {
          this.errmsg = '验证码只能为六位数字'
          return
        }
      }
      if (this.phone !== '') {
        const sj = /^[1]([3-9])[0-9]{9}$/
        if (sj.test(this.phone)) {
          this.errmsg = ''
          // eslint-disable-next-line consistent-return
          return true
        }
        this.errmsg = '手机号格式错误'
      }
    },
    confirmInfoChange () {
      // 点击勾选同意用户协议事件
      this.confirmInfo = !this.confirmInfo
      this.errmsg = this.confirmInfo ? '' : '请先勾选用户协议和隐私政策'
    },
    inputChange (type) {
      // 替换输入框中的非数字
      try {
        this[type] = this[type].replace(/[^\d]/g, '')
      } catch (e) {
        //
      }
    }
  }
}
</script>

<style lang='less' scoped>
.phone-login {
  .login-body {
    display: flex;
    height: 100%;
    justify-content: center;
    // padding-top: 0.06rem;
    box-sizing: border-box;
    .login-form {
      position: relative;
      // padding: 0 0.44rem 0 0.48rem;
      // padding: 0 0.2rem;
      width: 3rem;
      box-sizing: border-box;
      .login-form-content {
        width: 100%;
        .login-mobile-code {
          // margin-top: 0.16rem;
          .login-mobile-input-wrapper {
            height: 0.4rem;
            background-color: #fff;
            width: 100%;
            line-height: 0.22rem;
            > input {
              width: 100%;
              height: 100%;
              line-height: 100%;
              font-size: 0.14rem;
              padding: 0.12rem 0.16rem;
              border-radius: 0.06rem;
              box-sizing: border-box;
              border: 1px solid #cdcaca;
            }
          }
          .login-code-input-wrapper {
            margin-top: 0.16rem;
            .login-button-input {
              display: flex;
              justify-content: space-between;
              align-items: center;
              width: 100%;
              height: 0.4rem;
              line-height: 0.22rem;
              -webkit-box-sizing: border-box;
              -moz-box-sizing: border-box;
              box-sizing: border-box;
              padding: 0.13rem 0.16rem;
              border-radius: 0.06rem;
              background-color: #fff;
              padding: 0.12rem 0.16rem;
              border-radius: 0.06rem;
              box-sizing: border-box;
              border: 1px solid #cdcaca;
              .login-button-input-text {
                order: 2;
                height: 0.2rem;
                line-height: 0.2rem;
                flex-shrink: 0;
                font-size: 0.14rem;
                color: #222;
                cursor: pointer;
              }
              .login-button-input-text_disabled {
                color: #999;
                cursor: default;
              }
              .login-button-input-wrapper {
                display: flex;
                flex-grow: 1;
                order: 1;
                .login-button-input__input {
                  outline: none;
                  -webkit-box-shadow: none;
                  box-shadow: none;
                  background-color: transparent;
                  border: none;
                  height: 100%;
                  line-height: 100%;
                  font-size: 0.14rem;
                  width: 100%;
                }
              }
            }
          }
          .login-error {
            width: 100%;
            height: 0.32rem;
            padding-top: 0.04rem;
            padding-left: 0.16rem;
            font-size: 0.12rem;
            line-height: 0.16rem;
            color: #f04142;
            white-space: nowrap;
            outline: none;
          }
          .login-confirm-info {
            user-select: none;
            outline: none;
            line-height: 0.2rem;
            font-size: 0.12rem;
            display: flex;
            align-items: center;
            margin-top: 0.16rem;
            margin-bottom: 0.06rem;
            .login-confirm-info_checkbox {
              display: inline-block;
              width: 0.14rem;
              height: 0.14rem;
              margin-right: 0.04rem;
              border-radius: 0.02rem;
              border: 1px solid #d9d9d9;
              vertical-align: text-bottom;
              cursor: pointer;
            }
            .login-confirm-info_checkbox_checked {
              border: none;
              background-repeat: no-repeat;
              background-position-x: 50%;
              background-size: 0.14rem 0.14rem;
              background-image: url("~@/assets/icons/checked.png");
            }
            .login-confirm-info__before-text {
              color: #2c2c2c;
            }
            > a {
              color: #f7ac4f;
            }
          }
          .login-submit-btn-wrapper {
            // margin-top: 0.1rem;
            > button {
              cursor: pointer;
              width: 100%;
              height: 0.4rem;
              border: none;
              outline: none;
              line-height: 0.44rem;
              font-weight: 500;
              border-radius: 0.04rem;
              font-size: 0.14rem;
              text-align: center;
              background-color: rgb(247, 172, 79);
              color: #fff;
              border-radius: 0.06rem;
            }
            > .login-submit-btn-disabled {
              background: rgba(247, 172, 79, 0.5);
              color: #fff;
              cursor: default;
            }
          }
        }
      }
    }
    .login-form-title {
      font-weight: 600;
      font-size: 0.2rem;
      color: #000;
    }
  }
}
</style>
